import { createAction, props } from '@ngrx/store';

export const doLoadUser = createAction('[User] Loading User information');

export const doLoadUsersStandard = createAction(
	'[User] Loading Users for Employees list'
);

export const doLoadUsersSuper = createAction(
	'[User - Super] Loading Users for Employees list'
);

export const doLoadUserSuccess = createAction(
	'[API - Super] User Loaded successfully',
	props<{ user }>()
);

export const doLoadUserFailure = createAction('[API] User Load failed');

export const doLoadUsersSuperSuccess = createAction(
	'[API - Super] Users list load success',
	props<{ users }>()
);

export const doLoadUsersSuperFailure = createAction(
	'[API] Load Users list Failure'
);

export const doLoadUsersStandardSuccess = createAction(
	'[API] Users list load success',
	props<{ users }>()
);

export const doLoadUsersStandardFailure = createAction(
	'[API] Load Users list Failure'
);
